import React from 'react';
import { Link } from 'react-router-dom';

type PageFrameProps = {
  title: string;
  children: React.ReactNode;
  onPrimaryCta: () => void;
  onSecondaryCta: () => void;
};

export function PageFrame({ title, children, onPrimaryCta, onSecondaryCta }: PageFrameProps) {
  return (
    <div className="landing">
      <div className="landing-inner">
        <header className="landing-header">
          <div className="container landing-nav">
            <div className="nav-brand">
              <div className="brand-icon brand-icon-frame">
                <img src="/logo-transparent.png" alt="" />
              </div>
              <div>
                <div className="nav-title">EDGAR Insights</div>
                <strong>{title}</strong>
              </div>
            </div>
            <nav aria-label="Product">
              <ul className="nav-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/features">Features</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
              </ul>
            </nav>
            <div className="nav-actions">
              <button className="cta-secondary" type="button" onClick={onSecondaryCta}>
                Sign in
              </button>
              <button className="cta-button" type="button" onClick={onPrimaryCta}>
                Get started
              </button>
            </div>
          </div>
        </header>

        <main>{children}</main>

        <footer className="landing-footer">
          <div className="container">
            <p className="disclaimer">
              The content provided by EDGAR Insights is for informational and educational purposes only and is not intended
              as investment, legal, tax, or brokerage advice. All trading, investment, or financial decisions carry risk,
              including the potential loss of principal. Past performance is not indicative of future results.
            </p>
            <p className="disclaimer">
              By using this platform or its content, you acknowledge and agree that EDGAR Insights, its affiliates, and
              contributors do not guarantee accuracy, completeness, or timeliness of information and are not responsible
              for any losses or damages arising from your reliance on this content. You are solely responsible for your
              decisions, and we strongly recommend consulting a licensed financial, legal, or tax professional before
              taking any action based on the information provided.
            </p>
            <p className="disclaimer">
              Use of this platform constitutes acceptance of this disclaimer and your agreement to assume all risk associated with your decisions.
            </p>
            <div className="site-tagline">
              EDGAR Insights | AI-powered trading signals from SEC filings | Built for fundamental and event-driven teams.
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
